import SmallButton from '../components/buttons/small-button';

export default ({children, tabs, tab, setTab, disabledTabs = []}) => {
    return (
        <div class="tab-bar__bar">
            {!children && tabs.filter((name,index) => {
                return _.findIndex(disabledTabs, (i) => { return i === index}) === -1;
            }).map((name, index) => {
                return <SmallButton className={`tab-bar-button ${index == tab ? "tab-bar-button--toggled" : ""}`} onClick={() => setTab(index)} icon={<img src="/assets/logos/arrow-with-head.svg" />}>{ name }</SmallButton>
            })}
            { children && children }
        </div>
    )
}
